define.alias("checkout/components/input-stepper", "calendar/components/input-stepper");